var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpirits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.713867,
    y: 0.97168,
    width: 23.3155,
    height: 23.3156,
    rx: 3,
    fill: "#B89595"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1416 0H4.85787C3.56992 0.00144251 2.33514 0.513718 1.42443 1.42444C0.513712 2.33515 0.00143994 3.56994 0 4.85788V20.1421C0.00143994 21.4301 0.513712 22.6648 1.42443 23.5756C2.33514 24.4863 3.56992 24.9986 4.85787 25H20.1416C21.4296 24.9986 22.6645 24.4863 23.5753 23.5756C24.4861 22.6649 24.9985 21.4301 25 20.1421V4.85788C24.9985 3.56988 24.4861 2.33508 23.5753 1.42438C22.6645 0.513667 21.4296 0.0014166 20.1416 0ZM23.057 20.1421C23.0561 20.915 22.7486 21.6559 22.202 22.2024C21.6555 22.7489 20.9145 23.0562 20.1416 23.057H4.85787C4.08507 23.0561 3.3442 22.7487 2.79775 22.2022C2.2513 21.6558 1.94389 20.9149 1.94296 20.1421V4.85788C1.94389 4.08509 2.2513 3.34421 2.79775 2.79775C3.3442 2.2513 4.08507 1.9439 4.85787 1.94296H20.1416C20.9145 1.94379 21.6555 2.25115 22.202 2.79761C22.7486 3.34407 23.0561 4.08501 23.057 4.85788V20.1421Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_6679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0234 11.4333L16.0135 10.1924C15.4798 9.86303 15.1614 9.31884 15.1614 8.73663V3.88574H10.0864V8.73663C10.0864 9.31884 9.768 9.86303 9.23449 10.1924L7.22441 11.4333C6.1414 12.1018 5.66467 13.3125 6.03808 14.4458L8.32106 21.3724H16.9269L19.2098 14.4458C19.5833 13.3125 19.1064 12.1018 18.0234 11.4333ZM14.023 8.46233H11.2249V7.46227H14.023V8.46233ZM14.1371 9.48694C14.2785 9.94294 14.5473 10.3604 14.9192 10.6986L12.6239 12.1708L10.3288 10.6986C10.7005 10.3604 10.9693 9.94294 11.1107 9.48694H14.1371ZM14.023 4.91035V6.43766H11.2249V4.91035H14.023ZM18.1183 14.1544L16.0771 20.3478H9.17075L7.12954 14.1544C6.89696 13.4485 7.19387 12.6946 7.8685 12.2782L9.37739 11.3466L12.6239 13.4289L15.8704 11.3466L17.3795 12.2782C18.054 12.6946 18.3509 13.4486 18.1183 14.1544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7334 18.3216H15.5143V14.4053H9.7334V18.3216ZM10.8719 15.4299H14.3759V17.297H10.8719V15.4299Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_6679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4296,
    height: 17.4867,
    fill: "white",
    transform: "translate(2.91443 3.88574)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpirits);
export default __webpack_public_path__ + "static/media/spirits.cef7dc3a9a22e8d630b2b79d4e1690e2.svg";
export { ForwardRef as ReactComponent };